// @ts-nocheck
import _ from 'lodash';
import type { Vote } from './types';
import { getVoteCommentsInfo, logVoteToggleState, postVote, voteInit } from '../../apis/workspace_api/vote';
import FieldEditor from './FieldEditor.vue';
import { Toast } from 'patsnap-biz';

const FULL_WIDTH = 752;

export class FieldEditorService {

    public ptDialogAutoMounterManager?: any = undefined;

    constructor() {
    }

    static Dialog = FieldEditor

    folderId = '';
    spaceId = '';
    timezone = {};

    get id() {
        return `field$-${this.folderId}-${this.field?.field_id}`
    }

    get utcOffset(): string | number {
        return this.timezone?.utc_offset;
    }

    // 是否可以拖拽，否则需要自行使用 <FieldEditorService.Dialog v-if="isShow"/> 组件
    get draggableDialogMode():boolean {
        return !!this.ptDialogAutoMounterManager;
    }

    private x = 0;

    private y = 0;

    private h = 320;

    private w = 420;

    private readonly minH = 320;

    private readonly minW = 420;

    private readonly maxH = 580;

    private readonly maxW = 752;

    private extraSpace = 8;

    isShow = false;

    private isDragging = false;

    private isResizing = false;

    private clientRectCache: { clientWidth: number, clientHeight: number } | null = null;

    public value: null | string[] = null;

    aiCheckTip = false;

    filterWords: string = '';

    structor: null | string[] = null;

    field: {
        field_id: string,
        field_type: string,
    } | null = null;

    row: { [key: string]: any } | null = null;

    newValue: null | string[] = null;

    private changed = false;

    innerIsShowComments = false;

    get isShowComments() {
        return this.voteStatus.enabled && this.innerIsShowComments
    }

    set isShowComments(val: boolean) {
        if (!this.voteStatus.enabled) {
            console.error('isShowComments dont enabled');
        }
        // if (val) {
        //     this.initEditorRect();
        // }
        this.innerIsShowComments = val;
    }

    public currentUser: Vote.UserInfo|undefined;

    get currentUserId() {
        return this.currentUser?.user_id || '';
    }

    protected isSpaceOwner = false;

    get permissionsForComment() {
        return {
            isOwner: this.isSpaceOwner,
            edit: this.voteStatus.allow, // 能投票其实就可评论
        }
    }

    get statusClass() {
        if (!this.isShow) return {};
        return {
            'field-editor__draging': this.isDragging,
            'field-editor__resizing': this.isResizing,
        };
    }

    get dragCanvas() {
        return document.body;
    }

    private _openSrcElement: HTMLElement = null;
    initEditorRect(target: HTMLElement = this._openSrcElement) {
        // 优先计算左下区域，再右下，其次左上，最后右上
        if (!target) return;

        // @ts-ignore
        const { left, top, right, bottom } = target.getBoundingClientRect();
        const { clientWidth, clientHeight } = this.clientRect;

        const isLeftEnough = left > this.w + this.extraSpace;
        const isTopEnough = top > this.h + this.extraSpace;
        const isRightEnough = clientWidth - right > this.w + this.extraSpace;
        const isBottomEnough = clientHeight - bottom > this.h + this.extraSpace;

        const _x = {
            left: left - this.w - this.extraSpace,
            right: right + this.extraSpace,
        };

        const _y = {
            top: top - this.h,
            bottom: bottom,
        };

        const center = {
            x: (clientWidth - this.w) / 2,
            y: (clientHeight - this.h) / 2,
        };

        if (isLeftEnough && isBottomEnough) {
            // 左下
            this.x = _x.left;
            this.y = _y.bottom;
        } else if (isRightEnough && isBottomEnough) {
            // 右下
            this.x = _x.right;
            this.y = _y.bottom;
        } else if (isLeftEnough && isTopEnough) {
            // 左上
            this.x = _x.left;
            this.y = _y.top;
        } else if (isRightEnough && isTopEnough) {
            // 右上
            this.x = _x.right;
            this.y = _y.top;
        } else if (isBottomEnough) {
            // 下 左右居中
            this.x = center.x;
            this.y = _y.bottom;
        } else if (isTopEnough) {
            // 上 左右居中
            this.x = center.x;
            this.y = _y.top;
        } else if (isLeftEnough) {
            // 左 上下居中
            this.x = _x.left;
            this.y = center.y;
        } else if (isRightEnough) {
            // 右 上下居中
            this.x = _x.right;
            this.y = center.y;
        } else {
            // 居中
            this.x = center.x;
            this.y = center.y;
        }

        return this;
    }

    get editorStyles() {
        const w = this.isShowComments ? FULL_WIDTH : this.w;
        return {
            left: `${this.x}px`,
            top: `${this.y}px`,
            width: `${w}px`,
            height: `${this.h}px`,
            border: this.draggableDialogMode ? '1px solid #dfe1e6' : 'unset'
        };
    }

    get clientRect(): { clientWidth: number, clientHeight: number } {
        if (!this.clientRectCache) {
            const { clientWidth, clientHeight } = this.dragCanvas;
            this.clientRectCache = { clientWidth, clientHeight };
        }
        return this.clientRectCache;
    }

    setNewValue(newValue: string[], changed: boolean) {
        this.newValue = newValue;
        this.changed = changed;
        this.onValueUpdateFn(newValue);
        return this;
    }

    mouseMoveHandler: ((mousemoveEvent: MouseEvent) => void) | null = null;

    clearMouseMoveEvent() {
        if (this.mouseMoveHandler) {
            this.dragCanvas.removeEventListener('mousemove', this.mouseMoveHandler);
        }
        this.dragCanvas.dataset.fieldEditorDragging = String(false);
    }

    dragEditor(event: MouseEvent) {
        if (!this.draggableDialogMode) {
            return
        }
        // 计算相对位置
        const { x, y } = event;
        const offsetX = x - this.x;
        const offsetY = y - this.y;

        this.clientRectCache = null;
        const { clientWidth, clientHeight } = this.clientRect;

        this.clearMouseMoveEvent();

        // rvTrack('Custom Field Drag Popup', {
        //     type: this.field.field_type,
        // });

        this.mouseMoveHandler = _.throttle((mousemoveEvent) => {
            this.isDragging = true;
            let _x = mousemoveEvent.x - offsetX;
            let _y = mousemoveEvent.y - offsetY;

            const _left = clientWidth - this.w;
            const _top = clientHeight - this.h;
            if (_x <= this.extraSpace) _x = this.extraSpace;
            if (_x >= _left - this.extraSpace) _x = _left - this.extraSpace;
            if (_y <= this.extraSpace) _y = this.extraSpace;
            if (_y >= _top - this.extraSpace) _y = _top - this.extraSpace;

            this.x = _x;
            this.y = _y;
        }, 0);

        this.dragCanvas.addEventListener('mousemove', this.mouseMoveHandler);

        this.resetOnMouseUp();
    }

    resizeEditor() {
        if (!this.draggableDialogMode) {
            return
        }
        this.clientRectCache = null;

        const { clientWidth, clientHeight } = this.clientRect;

        this.clearMouseMoveEvent();

        this.mouseMoveHandler = _.throttle((mousemoveEvent) => {
            this.isResizing = true;

            const { clientX, clientY } = mousemoveEvent;

            let _w = Math.min(
                Math.max(clientX - this.x, this.minW),
                this.maxW
            );

            let _h = Math.min(
                Math.max(clientY - this.y, this.minH),
                this.maxH
            );

            if (_w + this.x + this.extraSpace > clientWidth) {
                _w = clientWidth - this.x - this.extraSpace;
            }

            if (_h + this.y + this.extraSpace > clientHeight) {
                _h = clientHeight - this.y - this.extraSpace;
            }

            if (this.isShowComments) {
                this.h = _h;
            } else {
                this.w = _w;
                this.h = _h;
            }
        }, 0);

        this.dragCanvas.addEventListener('mousemove', this.mouseMoveHandler);
        this.dragCanvas.dataset.fieldEditorDragging = String(true);

        this.resetOnMouseUp();
    }

    mouseupHandler: (() => void) | null = null;

    resetOnMouseUp() {
        this.clearMouseUpEvent();

        this.mouseupHandler = () => {
            this.clearMouseMoveEvent();

            this.isResizing = false;
            this.isDragging = false;
        };

        this.dragCanvas.addEventListener('mouseup', this.mouseupHandler);
    }

    clearMouseUpEvent() {
        if (this.mouseupHandler) {
            this.dragCanvas.removeEventListener('mouseup', this.mouseupHandler);
            this.mouseupHandler = null;
        }
    }

    hide() {
        if (!this.isShow) return;

        // 阻止隐藏
        if (!this.isDragging && !this.isResizing) {
            this.showDialog(false);
            Object.assign(this.voteStatus, {
                enabled: false,
                data: null,
                nodeId2voters: {},
            });
        }

        // 提交修改
        if (this.changed) {
            setTimeout(() => {
                this.onFinalSubmitFn({
                    newValue: this.newValue,
                    oldValue: this.value,
                });
            }, 18);
        }

        return this;
    }

    setEditor(status) {
        if (!status) {
            this.h = 268;
            this.w = 262;
        } else {
            this.h = 300;
            this.w = FULL_WIDTH;
        }
    }

    onValueUpdateFn:(newValue: string[]) => void = _.noop;
    public onValueUpdate(onValueUpdateFn:(newValue: string[]) => void) {
        this.onValueUpdateFn = onValueUpdateFn;
        return this;
    }

    onFinalSubmitFn:(change: {newValue: string[], oldValue:string[]}) => void = _.noop;
    public onSubmit(onFinalSubmitFn:(change: {newValue: string[], oldValue:string[]}) => void) {
        this.onFinalSubmitFn = onFinalSubmitFn;
        return this;
    }

    get isPatentField() {
        return this.row.PATENT_ID;
    }

    _i18n = null;

    get i18n() {
        if (!this._i18n) {
            console.error('no i18n')
        }
        return this._i18n
    }

    set i18n(_i18n) {
        this._i18n = _i18n
    }

    showDialog(bol:boolean) {
        this.isShow = bol;
        if (this.draggableDialogMode) {
            this.ptDialogAutoMounterManager.update(FieldEditorService.Dialog, {
                service: this
            })
            this.ptDialogAutoMounterManager.toggleOpenState(FieldEditorService.Dialog, bol);
        }
    }

    public open({
        target,
        field,
        value,
        row,
        folderId,
        spaceId,
        aiCheckTip,
    }) {
        const { field_option_value, field_layer_value } = field;

        if (['OPTION', 'LAYER'].indexOf(field.field_type) === -1) {
            throw new Error('field type is not OPTION or LAYER');
        }

        if (!folderId || !spaceId) {
            throw new Error('folderId or spaceId is required');
        }

        this.folderId = folderId;
        this.spaceId = spaceId;

        this.field = field;
        this.value = Array.isArray(value) ? [...value] : [];
        this.row = row;
        this.structor = field.field_type === 'OPTION' ? field_option_value : field_layer_value;

        this.clientRectCache = null;
        this._openSrcElement = target;

        this.changed = false;
        this.newValue = null;

        this.aiCheckTip = aiCheckTip;

        if (this.isPatentField) {
            voteInit({ // 会被缓存
                folder_id: this.folderId,
                field_id: this.field.field_id,
            }).then((d) => {
                this.voteStatus.allow = d.can_vote;
                if (!this.voteStatus.allow) {
                    this.voteStatus.enabled = false;
                } else {
                    this.voteStatus.enabled = d.vote_switch;
                }
                this.currentUser = d.user_info;
                this.isSpaceOwner = d.space_owner;
                this.timezone = d.timezone;
            })
            this.showDialog(true);
        } else {
            this.voteStatus.allow = false;
            this.voteStatus.enabled = false;
            this.showDialog(true);
        }
        return this;
    }

    destroy() {
        this.clearMouseMoveEvent();
        this.clearMouseUpEvent();
        this.filterWords = '';
        Object.assign(this.voteStatus, {
            enabled: false,
            data: null,
            nodeId2voters: {},
        });
        this.ptDialogAutoMounterManager.unregister(FieldEditorService.Dialog);
    }

    readonly voteStatus: Vote.VoteStatus = {
        allow: true,
        enabled: false,
        data: null,
        nodeId2voters: {},
    }

    private get commonVoteParams() {
        return {
            folder_id: this.folderId,
            field_id: this.field.field_id,
            data_type: 'PATENT',
            data_id: this.row.PATENT_ID,
        }
    }

    async updateVoteCommentsInfo() {
        const d = await getVoteCommentsInfo(this.commonVoteParams)
        this.setVoteStatusByResp(d);
    }

    public toggleComments(status) {
        if (status) {
            this.isShowComments = true
            this.draggableDialogMode ? this.w = this.maxW : this.setEditor(status);
        } else {
            this.isShowComments = false
            this.draggableDialogMode ? this.w = this.minW : this.setEditor(status);
        }
    }

    private setVoteStatusByResp(resp:Vote.VoteFetchResp) {
        this.voteStatus.data = resp;
        this.voteStatus.nodeId2voters = {};
        this.voteStatus.data.node_vote_info.forEach(votesInfo => {
            this.voteStatus.nodeId2voters[votesInfo.node_id] = {
                ...votesInfo,
                currentUserIncluded: !!_.find(votesInfo.voters, { user_id: this.currentUserId }),
            }
        })
    }

    public getVotersInfoByNodeId(nodeId): Vote.NodeVoteInfoInStatus | {} {
        return this.voteStatus.nodeId2voters[nodeId] || {}
    }

    async toggleVoteMode() {
        if (!this.voteStatus.allow) return
        this.voteStatus.enabled = !this.voteStatus.enabled;
        if (this.voteStatus.enabled) {
            // do noting, 改成放在组件里更新数据了
        } else {
            this.toggleComments(false);
        }
        await logVoteToggleState(this.voteStatus.enabled, _.pick(this.commonVoteParams, ['folder_id', 'field_id']))
    }

    async vote(bol: boolean, nodeId: string) {
        const d = await postVote(bol, {
            node_id: nodeId,
            ...this.commonVoteParams,
        })
        if (d.status) {
            this.setVoteStatusByResp(d.data);
        } else {
            if (d.error_code) {
                Toast({
                    message: this._i18n.t(`commonStatusCode.${d.error_code}`),
                    type: 'error',
                    showClose: true
                });
            } else {
                Toast({
                    message: d.error_msg,
                    type: 'error',
                    showClose: true
                });
            }
        }
    }
}

let fieldEditorService: FieldEditorService | null = null;

export function getFieldEditorServiceInstance(ptDialogAutoMounterManager) {
    if (!fieldEditorService) {
        fieldEditorService = new FieldEditorService();
    }
    fieldEditorService.ptDialogAutoMounterManager = ptDialogAutoMounterManager;
    return fieldEditorService;
}

export function destroyFieldEditorServiceInstance() {
    if (fieldEditorService) {
        fieldEditorService.destroy();
        fieldEditorService = null;
    }
}
